export default `
§ sidebar.switch.team: Équipe
§ sidebar.switch.person: Employé
§ sidebar.buttons.settings: Réglages
§ sidebar.buttons.print: Impression
§ sidebar.buttons.share: Share
§ sidebar.buttons.logout: Logout
§ sidebar.filters.all: à toute heure
§ sidebar.filters.year: année
§ sidebar.filters.halfYear: demi-année
§ sidebar.filters.month: mois
§ sidebar.filters.week: semaine
§ sidebar.team.total: Informations générales
§ sidebar.team.scope: modules
§ sidebar.team.author: Employés
§ sidebar.team.type: Types de tâches
§ sidebar.team.pr: injection de code
§ sidebar.team.day: Au jour le jour
§ sidebar.team.week: Le semaine
§ sidebar.team.month: Par mois
§ sidebar.team.files: Fichiers
§ sidebar.team.removedFiles: Fichiers supprimés
§ sidebar.team.tasks: Liste des tâches
§ sidebar.team.hours: Horaire
§ sidebar.team.commits: all commits
§ sidebar.team.changes: Tous les changements
§ sidebar.team.words: Mots populaires
§ sidebar.team.top: quiz
§ sidebar.team.settings: Réglages
§ sidebar.person.total: Informations générales
§ sidebar.person.money: Coût des travaux
§ sidebar.person.speed: Vitesse
§ sidebar.person.day: Au jour le jour
§ sidebar.person.week: Une semaine
§ sidebar.person.month: Par mois
§ sidebar.person.hours: Horaire
§ sidebar.person.commits: all commits
§ sidebar.person.changes: Tous les changements
§ sidebar.person.words: Mots populaires
§ sidebar.person.settings: Réglages
`;
